import { EmailHubStatusProvider } from "@circle-react/contexts/EmailHubStatusContext";
import { Container } from "../components/Container";
import { WorkflowTabs } from "../components/WorkflowTabs";
import { WorkflowsDataProvider } from "../context/WorkflowsDataProvider";
import type { WorkflowsDataProviderProp } from "../context/WorkflowsDataProvider";

export const AllWorkflows = (prop: Partial<WorkflowsDataProviderProp>) => (
  <WorkflowsDataProvider {...prop}>
    <EmailHubStatusProvider>
      <Container>
        <WorkflowTabs />
      </Container>
    </EmailHubStatusProvider>
  </WorkflowsDataProvider>
);
